import store from "@/store";

const catalogue_routes = [
    // Catalogue Management
  {
    path: '/company/products',
    name: 'CompanyProducts',
    component: () => import('../../views/company/catalogue_management/products/ProductList.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'PRODUCT_MANAGEMENT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/company/products-create',
    name: 'CompanyProductsCreate',
    component: () => import('../../views/company/catalogue_management/products/CreateProduct.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'PRODUCT_MANAGEMENT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
  {
    path: '/company/products-edit/:id',
    name: 'CompanyProductsEdit',
    component: () => import('../../views/company/catalogue_management/products/EditProduct.vue'),
    beforeEnter: (to, from, next) => {
      let obj = store.state.User.userData.user_type === 'buyer' && store.state.Auth.privileges.some(privilege => privilege.title === 'PRODUCT_MANAGEMENT')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' })
      }
    }
  },
]

export default catalogue_routes;